/**
 * DEV-2503. Имена клиентов и ЖК, добранные поштучно, — одни на вкладку: доска, таблица
 * и список по этапам показывают одних и тех же, а безымянный лид не запрашивается на
 * каждое открытие доски. Отдельным модулем без API, рядом с прочими общими данными
 * сессии: auth.store сбрасывает кэш при выходе и не тянет за собой клиентов API во
 * входной чанк.
 */
import { ref } from 'vue'

export const dealClientNames = ref(new Map<string, string>())
export const dealPropertyNames = ref(new Map<string, string>())

/** Выход или вход другим пользователем: имена — данные прежней сессии. */
export function clearDealNames() {
  dealClientNames.value = new Map()
  dealPropertyNames.value = new Map()
}
